// @flow

const weight = {
    light: 100,
    medium: 300,
    regular: 400,
    dark: 700, // FIXME: need to remove this line but update all the places which use it
    bold: 700
};

/**
 * FIXME: remove style object.
 * We don't have to keep font styles in js objects it's faster to wrtite
 * font-style: italic; than font-style: ${Fonts.style.italic};
 */
const style = {
    italic: 'italic'
};

// this is temporary solution
const size = {
    h1: '38px',
    h2: '34px',
    h3: '30px',
    h5: '20px',
    placeholder: '24px', // FIXME: I would use names contain size description rather than place where we use it
    xLarge: '22px',
    menu: '20px',
    large: '18px',
    regular: '16px',
    medium: '14px',
    small: '12px'
};

const fontStyle = {
    h1: {
        fontSize: size.h1
    },
    h2: {
        fontSize: size.h2
    },
    h5: {
        fontSize: size.h5
    },
    placeholder: {
        fontSize: size.placeholder
    },
    medium: {
        fontSize: size.medium
    },
    regular: {
        fontSize: size.regular
    }
};

export default {
    size,
    style,
    weight,
    fontStyle
};
